// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function action_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var action_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "action_name"), null));
  if (action_name.TAG === /* Ok */0) {
    var action_comment_required = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "action_comment_required"), null));
    if (action_comment_required.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                action_name: action_name._0,
                action_comment_required: action_comment_required._0
              }
            };
    }
    var e = action_comment_required._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".action_comment_required" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = action_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".action_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var actions = Decco.listFromJson(action_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "actions"), null));
  if (actions.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              actions: actions._0
            }
          };
  }
  var e = actions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".actions" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  action_decode ,
  t_decode ,
  
}
/* No side effect */
